import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../WordPressHosting.css';

const WordPressHostingHe = () => {
    const scrollToPricing = (e) => {
        e.preventDefault();
        const pricingSection = document.getElementById('pricing');
        if (pricingSection) {
            const headerOffset = 100;
            const elementPosition = pricingSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div dir="rtl">
            <Helmet>
                {/* Primary Meta Tags */}
                <title>אחסון וורדפרס בניהול עצמי - מהיר ומאובטח | Epicfinal</title>
                <meta name="title" content="אחסון וורדפרס בניהול עצמי - מהיר ומאובטח | Epicfinal" />
                <meta name="description" content="אחסון וורדפרס בניהול עצמי החל מ-₪19.90 לחודש. שליטה מלאה, אחסון SSD NVMe, SSL חינם, Cloudflare CDN, הגנה מפני תוכנות זדוניות והתקנה בלחיצה אחת." />
                <meta name="keywords" content="אחסון וורדפרס, וורדפרס בניהול עצמי, וורדפרס ללא ניהול, תוכניות אחסון וורדפרס, אחסון WP, אחסון ענן וורדפרס, אחסון וורדפרס מהיר, אחסון וורדפרס מאובטח, אחסון SSD וורדפרס, אחסון WooCommerce, אחסון מולטיסייט, אחסון בלוג וורדפרס" />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <meta name="author" content="Epicfinal" />
                <link rel="canonical" href="https://epicfinal.com/he/wordpress-hosting" />

                {/* Language & Locale */}
                <html lang="he" />
                <meta property="og:locale" content="he_IL" />
                <link rel="alternate" href="https://epicfinal.com/wordpress-hosting" hrefLang="en" />
                <link rel="alternate" href="https://epicfinal.com/he/wordpress-hosting" hrefLang="he" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/wordpress-hosting" />
                <meta property="og:title" content="אחסון וורדפרס בניהול עצמי - מהיר ומאובטח | Epicfinal" />
                <meta property="og:description" content="אחסון וורדפרס בניהול עצמי החל מ-₪19.90 לחודש. שליטה מלאה, SSD NVMe, SSL חינם, Cloudflare CDN והתקנה בלחיצה אחת." />
                <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
                <meta property="og:image:alt" content="Epicfinal אחסון וורדפרס מהיר בניהול עצמי" />
                <meta property="og:site_name" content="Epicfinal" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://epicfinal.com/he/wordpress-hosting" />
                <meta name="twitter:title" content="אחסון וורדפרס בניהול עצמי - מהיר ומאובטח | Epicfinal" />
                <meta name="twitter:description" content="אחסון וורדפרס בניהול עצמי החל מ-₪19.90 לחודש. שליטה מלאה, SSD NVMe, SSL חינם והתקנה בלחיצה אחת." />
                <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "WebPage",
                        "name": "אחסון וורדפרס בניהול עצמי - מהיר ומאובטח",
                        "description": "אחסון וורדפרס בניהול עצמי עם שליטה מלאה, אחסון SSD NVMe, SSL חינם, Cloudflare CDN ותמיכה ברמת התשתית.",
                        "url": "https://epicfinal.com/he/wordpress-hosting",
                        "provider": {
                            "@type": "Organization",
                            "name": "Epicfinal",
                            "url": "https://epicfinal.com"
                        },
                        "breadcrumb": {
                            "@type": "BreadcrumbList",
                            "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "בית",
                                    "item": "https://epicfinal.com/he"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "אחסון וורדפרס",
                                    "item": "https://epicfinal.com/he/wordpress-hosting"
                                }
                            ]
                        }
                    }
                `}</script>
            </Helmet>

            <div className="wp-hosting-page">
                {/* Hero Section */}
                <section className="wp-hero">
                    <div className="container">
                        <div className="wp-hero-content">
                            <div className="wp-logo-badge">
                                <i className="lab la-wordpress"></i>
                            </div>
                            <h1 className="wp-hero-title wp-hero-title-he">
                                אחסון וורדפרס
                            </h1>
                            <p className="wp-hero-subtitle">
                                אחסון מהיר וגמיש בניהול עצמי
                            </p>
                            <p className="wp-hero-description">
                                קבלו שליטה מלאה על אתר הוורדפרס שלכם. אתם מנהלים את העדכונים וההתאמות, ואנחנו מספקים תשתית מהירה, מאובטחת ואמינה.
                            </p>
                            <div className="wp-hero-buttons">
                                <a href="#pricing" onClick={scrollToPricing} className="btn-wp btn-primary">
                                    צפו בתוכניות ומחירים
                                </a>
                                <Link to="/contact1" className="btn-wp btn-secondary">
                                    צרו קשר
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="wp-features">
                    <div className="container">
                        <div className="wp-section-header">
                            <h2>תכונות מותאמות לוורדפרס</h2>
                            <p>כל מה שוורדפרס צריכה כדי לתפקד במיטבה</p>
                        </div>
                        <div className="wp-features-grid">
                            <div className="wp-feature-card">
                                <div className="wp-feature-icon">
                                    <i className="las la-bolt"></i>
                                </div>
                                <h3>מהיר כברק</h3>
                                <p>שרתים מותאמים עם מטמון מובנה לביצועי וורדפרס מהירים במיוחד.</p>
                            </div>
                            <div className="wp-feature-card">
                                <div className="wp-feature-icon">
                                    <i className="las la-sync"></i>
                                </div>
                                <h3>ניהול עצמי</h3>
                                <p>אתם שולטים בעדכוני הליבה, התבניות והתוספים ומחליטים מתי וכיצד לבצע אותם.</p>
                            </div>
                            <div className="wp-feature-card">
                                <div className="wp-feature-icon">
                                    <i className="las la-shield-alt"></i>
                                </div>
                                <h3>אבטחה משופרת</h3>
                                <p>צעדי אבטחה מתקדמים הכוללים סריקת תוכנות זדוניות והגנת חומת אש.</p>
                            </div>
                            <div className="wp-feature-card">
                                <div className="wp-feature-icon">
                                    <i className="las la-database"></i>
                                </div>
                                <h3>שליטה וגמישות</h3>
                                <p>התאימו את התקנת הוורדפרס, התוספים וההגדרות לצרכים המדויקים של האתר שלכם.</p>
                            </div>
                            <div className="wp-feature-card">
                                <div className="wp-feature-icon">
                                    <i className="las la-user-shield"></i>
                                </div>
                                <h3>תמיכה בתשתית</h3>
                                <p>סיוע בנושאי אחסון ותשתית, בזמן שניהול אתר הוורדפרס נשאר בשליטתכם.</p>
                            </div>
                            <div className="wp-feature-card">
                                <div className="wp-feature-icon">
                                    <i className="las la-rocket"></i>
                                </div>
                                <h3>התקנה בלחיצה אחת</h3>
                                <p>התקינו את וורדפרס בשניות עם תהליך ההגדרה האוטומטי שלנו.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Plans Section */}
                <section className="wp-pricing" id="pricing">
                    <div className="container">
                        <div className="wp-section-header">
                            <h2>תוכניות אחסון וורדפרס</h2>
                            <p>תוכניות אופטימליות לאתרי וורדפרס</p>
                        </div>
                        <div className="wp-pricing-grid">
                            {/* Starter Plan */}
                            <div className="wp-pricing-card">
                                <div className="wp-pricing-header">
                                    <h3>WordPress Starter</h3>
                                    <p className="wp-pricing-tagline">מיועד לעסקים קטנים, פרילנסרים ופרויקטים אישיים</p>
                                </div>
                                <div className="wp-pricing-price">
                                    <span className="wp-price-amount">₪19.90</span>
                                    <span className="wp-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="wp-pricing-features">
                                    <li><i className="las la-check"></i> <strong>אתר אחד</strong></li>
                                    <li><i className="las la-check"></i> 5GB NVMe SSD אחסון</li>
                                    <li><i className="las la-check"></i> תעבורה ללא הגבלה (שימוש הוגן)</li>
                                    <li><i className="las la-check"></i> אימייל ומסדי נתונים</li>
                                    <li><i className="las la-check"></i> עד 3 מסדי נתונים</li>
                                    <li><i className="las la-check"></i> WAF – חומת אש לאפליקציות ווב</li>
                                    <li><i className="las la-check"></i> הגנה מפני תוכנות זדוניות</li>
                                    <li><i className="las la-check"></i> תעודות SSL חינם</li>
                                    <li><i className="las la-check"></i> אינטגרציית Cloudflare</li>
                                    <li><i className="las la-check"></i> פאנל ניהול ידידותי למשתמש</li>
                                    <li><i className="las la-check"></i> התקנת וורדפרס בלחיצה אחת</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/wordpress-hosting/wordpress-starter&language=hebrew&currency=2"
                                    className="wp-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    מתחילים עכשיו
                                </a>
                            </div>

                            {/* Pro Plan */}
                            <div className="wp-pricing-card featured">
                                <div className="wp-pricing-badge">הפופולרי ביותר</div>
                                <div className="wp-pricing-header">
                                    <h3>WordPress Pro</h3>
                                    <p className="wp-pricing-tagline">אחסון מתקדם לאתרים צומחים</p>
                                </div>
                                <div className="wp-pricing-price">
                                    <span className="wp-price-amount">₪31.40</span>
                                    <span className="wp-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="wp-pricing-features">
                                    <li><i className="las la-check"></i> <strong>עד 3 אתרים נפרדים</strong></li>
                                    <li><i className="las la-check"></i> 15GB NVMe SSD אחסון</li>
                                    <li><i className="las la-check"></i> תעבורה ללא הגבלה (שימוש הוגן)</li>
                                    <li><i className="las la-check"></i> WAF והגנה מפני תוכנות זדוניות</li>
                                    <li><i className="las la-check"></i> הגנת אנטי-ספאם לאימייל</li>
                                    <li><i className="las la-check"></i> SSL חינם לכל הדומיינים</li>
                                    <li><i className="las la-check"></i> אינטגרציית Cloudflare</li>
                                    <li><i className="las la-check"></i> התקנת וורדפרס בלחיצה אחת</li>
                                    <li><i className="las la-check"></i> עדכוני וורדפרס בניהול עצמי</li>
                                    <li><i className="las la-check"></i> מטמון לטעינת דפים מהירה יותר</li>
                                    <li><i className="las la-check"></i> גישה ללוגים וסטטיסטיקות</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/wordpress-hosting/wordpress-pro&language=hebrew&currency=2"
                                    className="wp-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    מתחילים עכשיו
                                </a>
                            </div>

                            {/* Business Plan */}
                            <div className="wp-pricing-card">
                                <div className="wp-pricing-header">
                                    <h3>WordPress Business</h3>
                                    <p className="wp-pricing-tagline">ארחו מספר פרויקטים של לקוחות תחת פלטפורמה עוצמתית אחת</p>
                                </div>
                                <div className="wp-pricing-price">
                                    <span className="wp-price-amount">₪55.90</span>
                                    <span className="wp-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="wp-pricing-features">
                                    <li><i className="las la-check"></i> <strong>עד 10 אתרים</strong></li>
                                    <li><i className="las la-check"></i> 40GB NVMe SSD אחסון</li>
                                    <li><i className="las la-check"></i> תעבורה ללא הגבלה (~150 אלף ביקורים בחודש)</li>
                                    <li><i className="las la-check"></i> אידיאלי לחנויות WooCommerce</li>
                                    <li><i className="las la-check"></i> תמיכה ב-WordPress Multisite</li>
                                    <li><i className="las la-check"></i> מושלם לסוכנויות</li>
                                    <li><i className="las la-check"></i> תמיכה בפרויקטים גדולים</li>
                                    <li><i className="las la-check"></i> תמיכה בעדיפות</li>
                                    <li><i className="las la-check"></i> כל פיצ'רי ה-Pro כלולים</li>
                                    <li><i className="las la-check"></i> תכונות אבטחה מתקדמות</li>
                                    <li><i className="las la-check"></i> שותף אמין לסוכנויות</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/wordpress-hosting/wordpress-business&language=hebrew&currency=2"
                                    className="wp-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    מתחילים עכשיו
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Self-Managed Section */}
                <section className="wp-managed">
                    <div className="container">
                        <div className="wp-section-header">
                            <h2>שליטה מלאה בניהול האתר</h2>
                            <p>פתרון לאנשי מקצוע שמעדיפים לנהל את וורדפרס בעצמם</p>
                        </div>
                        <div className="wp-managed-grid">
                            <div className="wp-managed-card">
                                <i className="las la-code"></i>
                                <h3>למפתחים</h3>
                                <p>שליטה מלאה בהתאמות, בתוספים ובהגדרות של אתר הוורדפרס</p>
                            </div>
                            <div className="wp-managed-card">
                                <i className="las la-users-cog"></i>
                                <h3>לסוכנויות</h3>
                                <p>גמישות לניהול מספר אתרי לקוחות בהתאם לתהליך העבודה שלכם</p>
                            </div>
                            <div className="wp-managed-card">
                                <i className="las la-user-cog"></i>
                                <h3>למשתמשים טכניים</h3>
                                <p>אתם קובעים מתי לעדכן, מה להתקין וכיצד להגדיר את האתר</p>
                            </div>
                            <div className="wp-managed-card">
                                <i className="las la-piggy-bank"></i>
                                <h3>מחיר משתלם</h3>
                                <p>חיסכון בעלויות בזכות ניהול עצמאי של אתר הוורדפרס</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="wp-cta">
                    <div className="container">
                        <div className="wp-cta-content">
                            <h2>מוכנים להשיק את אתר הוורדפרס שלכם?</h2>
                            <p>התחילו עם אחסון וורדפרס מותאם היום</p>
                            <div className="wp-cta-buttons">
                                <Link to="/pricing-he" className="btn-wp btn-light">
                                    צפו בתוכניות מחירים
                                </Link>
                                <Link to="/contact1" className="btn-wp btn-outline">
                                    דברו עם מומחה
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default WordPressHostingHe;
